import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyUs } from './components/WhyUs';
import { Gallery } from './components/Gallery';
import { Reviews } from './components/Reviews';
import { ServiceArea } from './components/ServiceArea';
import { ContactCTA } from './components/ContactCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-background" data-id="element-0" data-mp="2riko97zkgfcl">
      <Header data-id="element-1" data-mp="2mmvob3jmwwfr" />
      <main data-id="element-2" data-mp="2mndqshww46w4">
        <Hero data-id="element-3" data-mp="2mjpvbd7vxaer" />
        <Services data-id="element-4" data-mp="2mjzplczyq3q9" />
        <WhyUs data-id="element-5" data-mp="31agq8u4rwpm3" />
        <Gallery data-id="element-6" data-mp="31ayq00qn9lyr" />
        <Reviews data-id="element-7" data-mp="31bianp7oiogh" />
        <ServiceArea data-id="element-8" data-mp="31c1iue7j1yhb" />
        <ContactCTA data-id="element-9" data-mp="2wk0a329kipw1" />
      </main>
      <Footer data-id="element-10" data-mp="2wjqft2hhpwkj" />
    </div>;
}